<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links" />
      <div class="content-plans-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3">
            <router-link
              tag="a"
              :to="{
                name: 'RegisterPlanCompany',
                params: {
                  id: $route.params.id,
                  slug: $route.params.slug,
                },
              }"
              class="content--card-register"
              style="min-height: 200px"
            >
              <img
                class="img-fluid"
                src="@/assets/img/image-plus.png"
                alt="image plus"
                title="image plus"
              />
            </router-link>
          </div>
          <template v-if="hasCompanyPlans">
            <div
              class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3"
              v-for="plan in companyPlans"
              :key="plan.id"
            >
              <CardCompanyPlan :plan="plan" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import CardCompanyPlan from "@/views/Company/components/CardCompanyPlan";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Listar Empresas",
          routerName: "ListCompanies",
        },
        {
          name: "Menu Empresa",
          routerName: "MenuCompany",
        },
        {
          name: "Planos",
          routerName: "ListPlansCompany",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("Company", ["companyPlans"]),
    hasCompanyPlans() {
      return (
        this.companyPlans &&
        Array.isArray(this.companyPlans) &&
        this.companyPlans.length > 0
      );
    },
    hasParams() {
      return this.$route.params && Object.keys(this.$route.params).length > 0;
    },
  },
  components: {
    Breadcrumb,
    CardCompanyPlan,
  },
  methods: {
    ...mapActions("Company", ["consultCompanyPlans", "setDataDefault"]),
    handleDataBreadcrumb() {
      this.links[2].name = `Menu - ${this.$route.params.slug}`;
      this.links[2].routerParams = {
        params: {
          ...this.$route.params,
        },
      };
    },
    checkHasPlanActive() {
      const hasPlanActive = this.companyPlans.find((item) => item.is_active);
      this.setDataDefault(["SET_HAS_PLAN_ACTIVE", hasPlanActive]);
    },
  },
  async mounted() {
    if (this.hasParams) {
      const payload = { id: this.$route.params.id };
      await this.consultCompanyPlans(payload);
      this.checkHasPlanActive();
      this.handleDataBreadcrumb();
    }
  },
};
</script>
